import { render, staticRenderFns } from "./Pride.vue?vue&type=template&id=10796632&lang=pug&"
import script from "./Pride.vue?vue&type=script&lang=js&"
export * from "./Pride.vue?vue&type=script&lang=js&"
import style0 from "./Pride.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports